<template>
  <v-app>
    <v-dialog v-model="dialog.open" max-width="600px">      
      <v-card>
        <v-card-title style="display:block;" class="styled-header">
          <span class="headline" v-html="popupMessages.cardBlock.modal.title"></span>
        </v-card-title>
        <v-card-text>
          <p v-html="popupMessages.cardBlock.modal.message"></p>  
          <!--<a class="btn block" appEvent="true"  appEventCategory="pop-up" appEventLabel="cartao desassociado automatico" @click="() => dialog.open = false">entendi</a>-->
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>

import {VDialog,VCard,VCardTitle,VCardText,VApp, VCardActions} from 'vuetify/lib'

import { popupMessages } from '../helpers/helpers.js'

export default {
  name: 'ModalCartaoDesassociado',
  methods: {
  },
  components: {
      VDialog,
      VCard,
      VCardTitle,
      VCardText,
      VCardActions,
      VApp
  },
  props: {
      open: Boolean
  },
  watch: { 
    open: {
      handler: function (newVal) {
        this.dialog.open = newVal || false;
      },
      deep: true
    }
  },
  created() {
    this.dialog.open = this.open || false;
  },
  data() {
    return {
    popupMessages,
      dialog: {
        open: false,
      },
    }
  }
}
</script>

<style lang="scss">
</style>
